import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import { useAppDispatch, useAppSelector } from '../../../../../../store';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InnerLayout from '../../../../../../layout/Inner';
import CreateStagedShipment from './components/CreateStagedShipment';
import { createStagedShipmentThunk } from '../../../../../../store/stagedShipmentCreate/thunks';
import { CreateStagedShipmentInput } from '../../../../../../core/api/lab.types';
import { getStagedShipmentMetaResponseSelector } from '../../../../../../store/stagedShipmentMetaList/selectors';
import ROUTES from '../../../../../../core/constants/routes.constants';
import { getStagedShipmentMetaThunk } from '../../../../../../store/stagedShipmentMetaList';
import { Loader } from '@omnigenbiodata/ui';
import {
  createStagedShipmentIsBusySelector,
  createStagedShipmentResponseSelector,
} from '../../../../../../store/stagedShipmentCreate/selectors';

function CreateShipmentScene() {
  const { t } = useTranslation('portal');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const stagedMeta = useAppSelector(getStagedShipmentMetaResponseSelector);
  const isBusy = useAppSelector(createStagedShipmentIsBusySelector);
  const createStagedShipmentResponse = useAppSelector(createStagedShipmentResponseSelector);

  const handleShipmentStart = (values: CreateStagedShipmentInput): void => {
    dispatch(createStagedShipmentThunk(values));
  };

  useEffect(() => {
    if (stagedMeta && stagedMeta !== null) {
      navigate(ROUTES.shipping);
    }
  }, [navigate, stagedMeta]);

  useEffect(() => {
    dispatch(getStagedShipmentMetaThunk());
  }, [dispatch]);

  useEffect(() => {
    if (createStagedShipmentResponse && createStagedShipmentResponse?.stagedShipmentMetaUuid !== '') {
      navigate(ROUTES.shipping);
    }
  }, [createStagedShipmentResponse, navigate]);

  return (
    <InnerLayout>
      <Container maxWidth="sm">
        <CreateStagedShipment onSubmit={handleShipmentStart} />
      </Container>
      <Loader isVisible={isBusy} label={t('loaders.loading') as string} />
    </InnerLayout>
  );
}

export default CreateShipmentScene;
